import React, { useEffect, useRef } from "react";
import { Col, Form, Input, InputNumber, message, Row, Select } from "antd";
import { useSetState } from "ahooks";
import { useAtom } from "jotai";
import { SActionBtn, SDrawerOrModal, SLowcodeList, SMessage, STableActions } from "shj-components";
import { SPUDataAtom } from '@/pages/productClass/components/store.js'

import ChooseSPUModal from "@/pages/productClass/components/ChooseSPUModal";
import ChooseSKUModal from "@/pages/productClass/components/ChooseSKUModal";
import { config } from './config.jsx'
import { batchInsertSpuRelation, getCategorySpuRelation, getunitList } from "@/services/product.ts";
import { isArray } from "lodash-es";
import { getEnums } from "@/services/homeService.ts";

const RelatedConstructionModal = (props) => {
  const { open, onClose, onReload, categoryId } = props;
  const [SPUData, setSPUData] = useAtom(SPUDataAtom)
  const listRef = useRef();
  const [state, setState] = useSetState({
    SPUOpen: false,
    SKUOpen: false,
    record: {},
    loading: false,
    typeList: [],
  })

  useEffect(() => {
    console.log(categoryId)
    if (open && categoryId) {
      console.log(111)
      getData()
    }
    if (open) {
      getOptions()
    }
  }, [categoryId, open]);

  const getData = () => {
    if (!categoryId) return;
    getCategorySpuRelation({ categoryId }).then(res => {
      if (isArray(res)) {
        setSPUData({ dataSource: res })
      }
    })
  }

  const getOptions = async () => {
    setState({ loading: true })
    try {
      const data = await getEnums('plus-product', 'com.shj.saas.plus.product.enums.ProductCombinationDetailSelectType')
      setState({ typeList: data?.map(item => ({ label: item.description, value: item.key })) })
    } finally {
      setState({ loading: false })
    }
  }

  const onChangeValue = (record, v, key) => {
    const newData = SPUData.dataSource.map(item => {
      if (item.productId === record.productId) {
        return {
          ...item,
          [key]: v,
          [key === 'selectType' ? 'skuIds' : ''] : [],
        }
      }
      return item
    })
    setSPUData((SPUData) => ({ ...SPUData, dataSource: newData }))
  }

  const onDelSPU = (productId) => {
    const newData = SPUData.dataSource.filter(item => item.productId !== productId)
    setSPUData((SPUData) => ({ ...SPUData, dataSource: newData }))
    message.success('删除成功')
  }

  const onAddSPU = () => {
    setState({ SPUOpen: true })
  }

  const onFinish = () => {
    // if (SPUData.dataSource?.length <= 0) {
    //   message.error('请选择至少一条SPU');
    //   return;
    // }
    if(SPUData.dataSource?.length > 0){
      const notSkuList = SPUData.dataSource?.filter(item => item.selectType !== 'ALL' && !(item.skuIds && item.skuIds?.length > 0))
      if (notSkuList?.length > 0) {
        const nameList = notSkuList.map(item => item.productName).join(',')
        message.error(`【${nameList}】请选择至少一条SKU`);
        return;
      }
    }

    setState({ loading: true })
    batchInsertSpuRelation({
      categoryIds: categoryId ? [categoryId] : props.ids,
      productList: SPUData.dataSource?.map(item => ({
        productId: item.productId,
        productName: item.productName,
        unitInfo: item.unitInfo,
        size: item.size,
        selectType: item.selectType,
        skuIds: item.skuIds,
      })),
    }).then(res => {
      message.success(res.message || '操作成功')
      setSPUData({ dataSource: [] })
      onClose?.()
      onReload?.()
    }).finally(() => {
      setState({ loading: false })
    })
  }

  const extension = {
    dataSource: SPUData.dataSource,
    events: { onAddSPU },
    customRender: {
      nameRender(v, record) {
        return <>
          <div style={{ maxWidth: 200, whiteSpace: 'wrap', wordBreak: 'break-all' }}>{v}</div>
          <div style={{ marginTop: 5 }}>{record.productId}</div>
        </>
      },
      numRender(v, record) {
        return <InputNumber style={{ width: '100%' }}
                            min={0.0001}
                            max={999999999.9999}
                            step={0.0001}
                            precision={4}
                            value={v || 1}
                            onChange={(v) => onChangeValue(record, v, 'size')}/>
      },
      typeSelectRender(v, record) {
        return <Select style={{ width: '100%' }}
                       value={v || 'ALL'}
                       options={state.typeList}
          // fieldNames={{ label: 'typeStr', value: 'code' }}
                       onChange={(v) => onChangeValue(record, v, 'selectType')}/>
      },
      actionRender(productId, record) {
        return <STableActions>
          {record.selectType !== 'ALL' &&
              <SActionBtn onClick={() => setState({ SKUOpen: true, record })}>SKU选择</SActionBtn>}
          <SActionBtn onClick={() => onDelSPU(productId)}>移除</SActionBtn>
        </STableActions>
      }
    }
  }

  const onReloadList = () => {

  }

  return <>
    <SDrawerOrModal
      title={'关联施工'}
      width={1000}
      open={open}
      loading={state.loading}
      onCancel={() => {
        onClose();
        setSPUData({ dataSource: [] });
      }}
      onOk={onFinish}
    >
      <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extension}/>
    </SDrawerOrModal>
    {state.SPUOpen && <ChooseSPUModal
        open={state.SPUOpen}
        onClose={() => setState({ SPUOpen: false })}
        onReload={onReloadList}
    />}
    {state.SKUOpen && <ChooseSKUModal
        spuData={state.record}
        open={state.SKUOpen}
        onClose={() => setState({ SKUOpen: false })}
        onReload={onReloadList}
    />}
  </>
}

export default RelatedConstructionModal